import axios from 'axios';
import { BackgroundImage } from '../types/bgImages.type';
import { ENV } from '../../../app/config/env';

export async function findBackgroundImageRequest(): Promise<BackgroundImage> {
	const response = await axios.get(ENV.REACT_APP_BACKGROUND_IMAGES);

	return response.data;
}
